import { SVTextInput } from '@/components/core';
import { Card, Typography, Grid } from '@mui/material';

export default function ThemeNameForm() {
  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Theme Name
      </Typography>
      <Grid container>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVTextInput
            name="name"
            label="Theme Name"
            rules={{ required: true }}
          />
        </Grid>
      </Grid>
    </Card>
  );
}
